import api from '.';
import { PipingProjectDetail } from '../pages/PipingProjectDetail/pipingProjectDetailSlice';

interface QueryPipingProjectDetail {
  pipingWorkTypeId: number;
  pipingPlantTypeId: number | null;
  pipingModelTypeId: number | null;
}

export interface UpdatePipingProjectDetail {
  projectId: number;
  pipingProjectDetail: QueryPipingProjectDetail;
}

export async function getPipingProjectDetail(
  projectId: number
): Promise<PipingProjectDetail> {
  const { data } = await api.get(`/piping-project-details/${projectId}`);

  return data;
}

export async function updatePipingProjectDetail({
  projectId,
  pipingProjectDetail
}: UpdatePipingProjectDetail): Promise<PipingProjectDetail> {
  const { data } = await api.put(
    `/piping-project-details/${projectId}`,
    pipingProjectDetail
  );

  return data;
}
